import classNames from 'classnames';
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { actions } from '../../../Slice/PersonProfileSlice';
import { Executive } from '../../../Types/PersonTypes';
import { SalesAlignmentItem, SalesAlignmentRow } from '../../../Types/GlobalTypes';
import { selectAlignmentRowStaff, selectSalesAlignmentPersons, selectSearchedAffinityMSPerson, selectSearchedAffinityMSPersonLoading, selectSearchedMultiSalesPerson, selectSearchedMultiSalesPersonLoading } from '../../../Selector/PersonProfileSelector';
import AlignmentPopoverList from './AlignmentPopoverList';
import { SearchResultSection, SearchResultsRequest } from '../../../Types/AffinitySearchTypes';
import { getLangCookie, validateSearchQuery } from '../../../Utils/UtilityFunctions';
import { actions as affinityActions } from '../../../Slice/AffinitySearchResultsSlice';
import { selectExtendedLoading, selectExtendedSearchLoaded, selectPeopleData, selectSearchResultsPage, selectLoading, selectSearchLoaded, selectedAddRowPopoverLoading, selectedAddRowPopoverExtendedLoading, selectedAddRowPopoverLoaded, selectedAddRowPopoverExtendedLoaded, selectedAddRowPopoverPeopleData, selectedAddRowPopoverResultsPage } from '../../../Selector/AffinitySearchSelector';
import { actions as helperActions } from '../../../Slice/HelperSlice';
import { actions as personProfileActions } from '../../../Slice/PersonProfileSlice'
const Wrapper = styled.div`
 &.add-new-row-popover {
  border-radius: 14px;
  background: #FFF;
  height: 280px;
  width: 230px;
  &.noStaff {
    .empty-list {
      width: 100%;
      height: 80%;
    }
  }
  }
`;
type Props = {
  currentUser: Executive | null;
  userIds: SalesAlignmentRow[];
  rowId: number;
  personsList: Executive;
  closePopover: () => void;
};
const defaultProps = {
  currentUser: [],
  userIds: [],
  rowId: 0,
  personsList: [],
}

const AddAlignmentRowPopover = function AddAlignmentRowPopover(props: Props) {
  const { currentUser, rowId, personsList, closePopover } = props
  const [query, setQuery] = useState('');
  const dispatch = useDispatch();
  const alignmentRowStaff = useSelector(selectAlignmentRowStaff(rowId));
  const salesAlignmentPersons = useSelector(selectSalesAlignmentPersons);
  const loading: boolean = useSelector(selectedAddRowPopoverLoading(rowId))
  const extendedLoading: boolean = useSelector(selectedAddRowPopoverExtendedLoading(rowId))
  const loaded: boolean = useSelector(selectedAddRowPopoverLoaded(rowId))
  const extendedLoaded: boolean = useSelector(selectedAddRowPopoverExtendedLoaded(rowId))
  const peopleData: SearchResultSection = useSelector(selectedAddRowPopoverPeopleData(rowId))
  const { count, linkedInCount } = peopleData ?? {};
  const totalSearchCount = linkedInCount ? count + linkedInCount : count;;
  const affinityPage: number = useSelector(selectedAddRowPopoverResultsPage(rowId))
  const page: number = useSelector(selectSearchResultsPage);
  const staffPage = alignmentRowStaff.page;
  const staffLoading = alignmentRowStaff.loading;
  const totalStaff = alignmentRowStaff.count;
  const staffData = alignmentRowStaff.staff;
  const [firstAPICall, setFirstAPICall] = useState(false);
  const searchedAffinityPerson = useSelector(selectSearchedAffinityMSPerson);
  const searchedAffinityPersonLoading = useSelector(selectSearchedAffinityMSPersonLoading);
  const [extendedAffinityPersonId, setExtendedAffinityPersonId] = useState<number | null>(null);
  const [disablePersonId, setDisablePersonId] = useState<number | null>(null);
  const [lastFetchedCompanyId, setLastFetchedCompanyId] = useState<number | null>(null);
  const effectiveCompanyId = currentUser?.companyId ?? salesAlignmentPersons?.rows?.[0]?.currentUser?.companyId ?? 0;

  useEffect(() => {
    if (effectiveCompanyId > 0 && effectiveCompanyId !== lastFetchedCompanyId) {
      dispatch(actions.addAlignmentRow({
        query: '',
        page: 1,
        companyId: effectiveCompanyId,
        screenName: 'multiSales',
        rowId,
      }))
      setLastFetchedCompanyId(effectiveCompanyId);
    }
  }, [
    effectiveCompanyId,
    rowId,
    lastFetchedCompanyId,
    dispatch,
  ]);

  const disabledIds = useMemo(() => {
    const rows = salesAlignmentPersons?.rows ?? [];
    const currentRow = rows.find((row) => row.rowId === rowId);

    const leftBaseColumnIds = rows
      .filter((row) => row.rowId !== rowId)
      .map((row) => row.currentUser?.personId)
      .filter((id): id is number => typeof id === 'number' && id > 0);

    const currentRowPersonIds = (currentRow?.personsList ?? [])
      .map((item) => item?.person?.personId)
      .filter((id): id is number => typeof id === 'number' && id > 0);

    return [...new Set([...leftBaseColumnIds, ...currentRowPersonIds])];
  }, [rowId, salesAlignmentPersons?.rows]);

  const buildAlignmentPayload = (affinityPersonId: number) => {
    const currentRow = salesAlignmentPersons.rows?.find((row) => row.rowId === rowId);
    const profilePersonId = personsList?.personId ?? currentRow?.personsList?.[0]?.person?.personId;

    const affinityWasSelectedBefore = Boolean(currentRow?.currentUser?.personId);
    const affinityChanged = affinityWasSelectedBefore && currentRow?.currentUser?.personId !== affinityPersonId;

    const rowHasExtraPeople = (currentRow?.personsList?.length ?? 0) > 1;
    const shouldSendPersonIds = affinityChanged && rowHasExtraPeople;

    const extraPersonIds = (currentRow?.personsList ?? [])
      .slice(1)
      .map((item: SalesAlignmentItem) => item?.person?.personId)
      .filter((id): id is number => typeof id === 'number' && id > 0 && id !== profilePersonId);

    const personIds = shouldSendPersonIds ? extraPersonIds.join(',') : '';

    return {
      personId: profilePersonId,
      ...(personIds ? { personIds } : {}),
      affinityPerson: affinityPersonId,
      rowId: rowId,
    }
  }
  const getAlignmentRow = (selectedAffinityPersonId: number, selectedAffinityPersonType?: string) => {

    if (selectedAffinityPersonType === 'LIVESEARCH') {
      setExtendedAffinityPersonId(selectedAffinityPersonId);
      const currentRowId = salesAlignmentPersons?.rows?.find((row) => row.rowId === rowId);
      const profilePersonId = personsList?.personId ?? currentRowId?.personsList?.[0]?.person?.personId;
      dispatch(actions.getSearchedPersonProfileInsights({
        personId: selectedAffinityPersonId,
        type: selectedAffinityPersonType,
        affinity_person: profilePersonId,
        alignmentType: 'affinity',
        rowId: rowId,
      }))
    } else {
      dispatch(actions.getMultipleSalesAlignment(
        buildAlignmentPayload(selectedAffinityPersonId),
      ));

      closePopover();
      setQuery('');

    }

  }

  // for extended search
  useEffect(() => {
    if (searchedAffinityPerson?.person?.personId && searchedAffinityPerson.rowId === rowId) {
      if (searchedAffinityPerson?.person?.notification === "Profile does not exists.") {
        dispatch(helperActions.setNotification({
          message: searchedAffinityPerson?.person?.notification,
          proTip: false,
          rightPlacement: false,
          groupId: 0,
          classnameFlag: false,
        }))
        setDisablePersonId(extendedAffinityPersonId);
      } else {
        closePopover();
        dispatch(actions.getMultipleSalesAlignment(
          buildAlignmentPayload(searchedAffinityPerson?.person?.personId ?? 0),
        ))
        setQuery('');
      }
    }
  }, [searchedAffinityPerson]);

  const onSearching = (q: string) => {
    setQuery(q);
    if (q.trim() === '') {
      return;
    } else {
      const searchQuery = validateSearchQuery(q.trim());
      if (searchQuery.length === 0) {
        return;
      }
      const obj: SearchResultsRequest = {
        query: searchQuery.trim(),
        screenName: 'person',
        page: 1,
        defaultLanguage: getLangCookie(),
        from: "multiSales",
        searchContext: 'affinity',
        rowId: rowId,
      }
      setFirstAPICall(true);
      dispatch(affinityActions.affinityPopoverSearchResultsReset({
        searchContext: "affinity",
        rowId: rowId,
      }))
      dispatch(affinityActions.multiSalesAffinitySearchLoading(obj));
    }
  };

  const fetchMoreStaff = () => {
    if (query.trim() === '') {
      if (currentUser?.companyId !== 0) {
        dispatch(actions.addAlignmentRow({
          query,
          page: staffPage,
          companyId: currentUser?.companyId ?? 0,
          screenName: 'multiSales',
          rowId: rowId,
        }));
        return;
      }
    } else {
      const searchQuery = validateSearchQuery(query.trim());
      if (searchQuery.length === 0) {
        return;
      }
      const obj: SearchResultsRequest = {
        query: searchQuery.trim(),
        screenName: 'person',
        page: affinityPage + 1,
        defaultLanguage: getLangCookie(),
        from: "multiSales",
        searchContext: 'affinity',
        rowId: rowId,
      };
      setFirstAPICall(false);
      dispatch(affinityActions.multiSalesAffinitySearchLoading(obj));
    }
  };
  return (
    <Wrapper
      className={classNames("add-new-row-popover")}
    >
      <AlignmentPopoverList
        staff={staffData}
        totalStaff={totalStaff}
        loading={staffLoading}
        searchLoading={loading}
        extendedLoading={extendedLoading}
        searchLoaded={loaded}
        extendedLoaded={extendedLoaded}
        searchData={peopleData?.persons ?? []}
        totalSearchCount={totalSearchCount}
        disabledIds={disabledIds}
        onSelect={getAlignmentRow}
        onFetchMore={fetchMoreStaff}
        onSearching={onSearching}
        query={query}
        scrollContainerId={`scrollPeople-multisales-addrow-${rowId}`}
        firstAPICall={firstAPICall}
        currentCompanyId={currentUser?.companyId ?? 0}
        spinnerLoading={searchedAffinityPersonLoading}
        disabledPersonId={disablePersonId}
      />
    </Wrapper>
  );
};
AddAlignmentRowPopover.defaultProps = defaultProps
export default AddAlignmentRowPopover;
